// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.order-summary[data-v-70d8f17e] {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
